import React from "react";
import PlainEditor from "../../../../../../../merchant/panel/scripts/shared/editor/plainEditor.js";
export default function CategoryPromotions(props) {
    return (React.createElement("div", { className: "one-time-offers-container" }, props.promotions.map((promotion, index) => (React.createElement("div", { className: "one-time-offer-container", key: index },
        React.createElement(PlainEditor, { editable: false, example: promotion.description, label: "", onChange: () => { } }))))));
}
